import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import {
  changeClientProfileEntryStatusPending,
  changeClientProfileEntryStatusFulfilled,
  changeClientProfileEntryStatusRejected,
} from '../actions';
import {
  sendApiRequest, notifyWarning, notifyError,
} from '../../../actions';
import { CLIENT_PROFILE_DETAILS_ENTRY_STATUS } from '../constants/clientProfileEntryDetailsStatusMessages copy';
import { CHANGE_CLIENT_PROFILE_ENTRY_STATUS } from '../types';

const createPayload = payload => ({
  method: 'post',
  url: 'Client/ChangeClientActiveStatus',
  onSuccess: [changeClientProfileEntryStatusFulfilled,
    response => (!response.data ? notifyWarning(CLIENT_PROFILE_DETAILS_ENTRY_STATUS.NOT_FOUND) : { type: '' })],
  onError: [
    changeClientProfileEntryStatusRejected,
    () => notifyError(CLIENT_PROFILE_DETAILS_ENTRY_STATUS.NOT_FOUND),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const changeClientProfileEntryStatusEpic$ = action$ => action$.pipe(
  ofType(CHANGE_CLIENT_PROFILE_ENTRY_STATUS.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(changeClientProfileEntryStatusPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default changeClientProfileEntryStatusEpic$;


// WEBPACK FOOTER //
// ./src/features/client-profile/epics/changeClientProfileEntryStatusEpic.js